import "./footer.css"
import { Link } from "react-router-dom"
import { FaCreditCard, FaPaypal } from "react-icons/fa"
import { SiVenmo } from "react-icons/si"
import { useAuth } from "../../context/AuthContext"
import { useContent } from "../../context/ContentContext"

const Footer = () => {
  const { isAuthenticated, openSignIn, signOut } = useAuth()
  const { confirmDiscardUnsavedChanges } = useContent()

  const handleSignOut = () => {
    if (confirmDiscardUnsavedChanges()) {
      signOut()
    }
  }

  return (
    <footer className="footer">
      <div className="footer-container">
        {/* Service Times and Contact Info */}
        <div className="footer-column">
          <h3>Service Times</h3>
          <p>Friday 7:30pm & Saturday 6:30pm</p>
          <p>Sunday 9:45am</p>

          <div className="divider"></div>

          <h3>Contact Us</h3>
          <p>
            <i className="fas fa-phone"></i> (267) 984-3132
          </p>
          <p>
            <i className="fas fa-envelope"></i> philadelphiashalemag@gmail.com
          </p>
        </div>

        {/* Location and Map */}
        <div className="footer-column">
          <h3>Location</h3>
          <p>2840 HOLME AVE, PHILADELPHIA PA, 19152</p>
          <div className="map-container">
            <iframe
              src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3048.243893683524!2d-75.0301847!3d40.0512788!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x89c6b7bc4a5a16e7%3A0x1df77b3d7b8b1de!2s2840%20Holme%20Ave%2C%20Philadelphia%2C%20PA%2019152%2C%20USA!5e0!3m2!1sen!2sus!4v1699976149566!5m2!1sen!2sus"
              width="100%"
              height="150"
              style={{ border: 0 }}
              allowFullScreen=""
              loading="lazy"
              title="Google Map"
            ></iframe>
          </div>
        </div>

        {/* Giving */}
        <div className="footer-column">
          <h3>Giving</h3>
          <div className="payment-icons">
            <FaCreditCard />
            <FaPaypal />
            <SiVenmo />
          </div>
          <div className="social-icons">
            <a href="https://www.facebook.com/psagchurch" target="_blank" rel="noopener noreferrer">
              <i className="fab fa-facebook"></i>
            </a>
            <a href="https://www.youtube.com/@psagchurch" target="_blank" rel="noopener noreferrer">
              <i className="fab fa-youtube"></i>
            </a>
            <a href="https://www.instagram.com/psagchurch/" target="_blank" rel="noopener noreferrer">
              <i className="fab fa-instagram"></i>
            </a>
          </div>
          <div className="footer-auth">
            {isAuthenticated ? (
              <>
                <Link to="/admin/activity" className="footer-activity-link">
                  Activity Log
                </Link>
                <button type="button" className="footer-sign-btn footer-sign-btn--out" onClick={handleSignOut}>
                  Sign Out
                </button>
              </>
            ) : (
              <button type="button" className="footer-sign-btn" onClick={openSignIn}>
                Sign In
              </button>
            )}
          </div>
        </div>
      </div>

      {/* Footer Bottom Section */}
      <div className="footer-bottom">
        <p>&copy; {new Date().getFullYear()} Philadelphia Shalem Assembly of God. All Rights Reserved.</p>
      </div>
    </footer>
  )
}

export default Footer
